module.exports = __webpack_public_path__ + "static/media/3.c4fb05a7.jpg";